import { render, staticRenderFns } from "./PowerLadderFolders.vue?vue&type=template&id=51dbf2f6&scoped=true"
import script from "./PowerLadderFolders.vue?vue&type=script&lang=js"
export * from "./PowerLadderFolders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51dbf2f6",
  null
  
)

export default component.exports